import React from "react";
import BannerZip from "../Utils/GenericUI/Banner_zip.jsx";
//import { header, Body } from "../Utils/StaticData/UserCreationStaticData";
import { Body } from "../Utils/StaticData/EnrollStepsStaticData";
import history from "../Utils/History";
import RemoveRedEyeIcon from "@material-ui/icons/RemoveRedEye";
import SimpleReactValidator from "simple-react-validator";
import { connect } from "react-redux";
import {
  signUp,
  guestLogin,
  successfulSignUp,
  setStateParams,
} from "../Redux/Actions/webAppActions";
// import Footer1 from "../Utils/GenericUI/Footer1";
import Footer1 from "../Utils/GenericUI/Footer1.jsx";
import FooterContainer from "./Footer/FooterContainer.js";
import Header from "./Header";
//import HeaderContainer from "./Header/HeaderContainer.js";
import { INITIAL_STATE } from "./initialState";
import { Text } from "react-internationalization";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
class UserSignUp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      passwrd: "",
      firstName: "",
      lastName: "",
      confrmPasswrd: "",
      showPswd: false,
      pswdEye: false,
      showConfirmPswd: false,
      confirmPswdEye: false,
      emailError: false,
      firstNameError: false,
      lastNameError: false,
      pswdError: false,
      confirmPwdEmptyError: false,
      confirmPswdError: false,
      modified: false,
      success: false,
      snackBarOpen: false,
      snackBarMsg: "",
      vertical: "top",
      horizontal: "center",
    };
    this.validator = new SimpleReactValidator();
  }
  componentDidMount() {
    window.scroll(0, 0);
  }

  handleChange = async (event) => {
    const { passwrd } = this.state;
    const name = event.target.name;
    const value = event.target.value;
    const emailError =
      name === "email" &&
      (!this.validator.check(value, "email") || value === "");
    const confirmPwdEmptyError = name === "confrmPasswrd" && value === "";
    const firstNameError = name === "firstName" && value === "";
    const lastNameError = name === "lastName" && value === "";
    const pswdError = name === "passwrd" && value === "";
    const confirmPswdError =
      name === "confrmPasswrd" && (value === "" || passwrd !== value);

    await this.setState({
      [name]: value,
      emailError: emailError,
      pswdError: pswdError,
      confirmPswdError: confirmPswdError,
      confirmPwdEmptyError: confirmPwdEmptyError,
      firstNameError: firstNameError,
      lastNameError: lastNameError,
      modified: true,
    });
  };

  handleFocus = (name) => (event) => {
    event.preventDefault();
    const showPswdEye = name === "passwrd";
    const showConfirmPswdEye = name === "confrmPasswrd";
    this.setState({
      pswdEye: showPswdEye,
      confirmPswdEye: showConfirmPswdEye,
    });
  };

  handleOnBlur = (name) => (event) => {
    event.preventDefault();
    const {
      showConfirmPswd,
      showPswd,
      email,
      passwrd,
      confrmPasswrd,
      firstName,
      lastName,
    } = this.state;
    const showPswdEye = name === "passwrd" && showPswd;
    const showConfirmPswdEye =
      name === "confrmPasswrd" && showConfirmPswd;
    const emailError =
      name === "email" &&
      (!this.validator.check(email, "email") || email === "");
    const pswdError = passwrd === "";
    const confirmPwdEmptyError =
      name === "confrmPasswrd" && confrmPasswrd === "";
    const firstNameError = name === "firstName" && firstName === "";
    const lastNameError = name === "lastName" && lastName === "";
    const confirmPswdError =
      confrmPasswrd === "" || passwrd !== confrmPasswrd;
    this.setState({
      pswdEye: showPswdEye,
      confirmPswdEye: showConfirmPswdEye,
      emailError: emailError,
      pswdError: pswdError,
      firstNameError: firstNameError,
      lastNameError: lastNameError,
      confirmPswdError: confirmPswdError,
      confirmPwdEmptyError: confirmPwdEmptyError,
    });
  };

  showPswd = (name, toggle) => (event) => {
    document.getElementById(name).focus();
    const eyeIcon = name === "passwrd" ? "pswdEye" : "confirmPswdEye";
    const show = name === "passwrd" ? "showPswd" : "showConfirmPswd";
    this.setState({
      [eyeIcon]: true,
      [show]: toggle,
    });
  };

  signUp = async (e) => {
    e.preventDefault();
    const { email, passwrd, confrmPasswrd, firstName, lastName } = this.state;

    const emailError = !this.validator.check(email, "email") || email === "";

    const confirmPswdError =
      confrmPasswrd === "" || passwrd !== confrmPasswrd;

    if (emailError) {
      this.setState({
        snackBarOpen: true,
        snackBarMsg:
          this.props.lang === "es"
            ? "El formato del correo electrónico es incorrecto"
            : "Email format is incorrect",
      });
      return;
    }
    if (!passwrd) {
      this.setState({
        snackBarOpen: true,
        snackBarMsg:
          this.props.lang === "es"
            ? "Por favor, ingrese contraseña"
            : "Please enter Password",
      });
      return;
    }
    if (!firstName) {
      this.setState({
        snackBarOpen: true,
        snackBarMsg:
          this.props.lang === "es"
            ? "Por favor, introduzca el nombre"
            : "Please enter First Name",
      });
      return;
    }
    if (!lastName) {
      this.setState({
        snackBarOpen: true,
        snackBarMsg:
          this.props.lang === "es"
            ? "Por favor ingrese apellido"
            : "Please enter last Name",
      });
      return;
    }
    if (confirmPswdError) {
      this.setState({
        snackBarOpen: true,
        snackBarMsg:
          this.props.lang === "es"
            ? "Las contraseñas no coinciden - Vuelva a ingresar"
            : "Passwords do not match - Please Re-enter",
      });
      return;
    }
    let body = {
      emailAddress: email,
      password: passwrd,
      reconfirmPwd: confrmPasswrd,
      firstName: this.state.firstName,
      lastName: this.state.lastName,
    };
    body = { ...body, customerId: this.props?.customerId };
    const signup = await this.props.signUp(body);
    if (signup.message === "SUCCESS") {
      this.props.successfulSignUp(true);
      // this.props.setStateParams("firstName", firstName);
      // this.props.setStateParams("lastName", lastName);
      history.push("/e-Enroll/login");
    } else {
      this.setState({
        snackBarOpen: true,
        snackBarMsg:
          this.props.lang === "es"
            ? "El usuario ya existe. ¡Por favor regístrese con una nueva cuenta de correo electrónico!"
            : "User Already Exists. Please register with new email account !!",
      });
    }
  };
  //TODO- agentLOgin, guestLogin
  continueAsGuest = async (e) => {
    e.preventDefault();
    const guestData = await this.props.guestLogin(this.props?.customerId);
    if (guestData.data === "Logged in as guest")
      history.push("/e-Enroll/Sharp/Individual/yearSelectionGuest");
    else {
      this.setState({
        snackBarOpen: true,
        snackBarMsg:
          this.props.lang === "es"
            ? "Error de inicio de sesion"
            : "Login Failed",
      });
    }
  };
  login = (e) => {
    e.preventDefault();
    this.setState({
      emailError: false,
      firstNameError: false,
      lastNameError: false,
      pswdError: false,
      confirmPwdEmptyError: false,
      confirmPswdError: false,
    });
    history.push("/webapp/Sharp/Individual/userLogin");
  };

  handleClick = () => {
    this.setState({
      snackBarOpen: true,
    });
  };

  handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({
      snackBarOpen: false,
    });
  };

  render() {
    const {
      signupKey,
      confirmsignupKey,
      email,
      showPswd,
      showConfirmPswd,
      pswdEye,
      confirmPswdEye,
      emailError,
      firstName,
      firstNameError,
      lastName,
      lastNameError,
      pswdError,
      confirmPswdError,
      //SONAR confirmPwdEmptyError,
      snackBarOpen,
      snackBarMsg,
      vertical,
      horizontal,
    } = this.state;
    return (
      <div id="userLogin">
        {/* <Header hide={true} /> */}
        {/* <HeaderContainer hide={true}/> */}
        <BannerZip header={" "} Body={Body} />
        <Snackbar
          open={snackBarOpen}
          autoHideDuration={6000}
          onClose={this.handleClose}
          anchorOrigin={{ vertical, horizontal }}
          key={vertical + horizontal}
        >
          <Alert onClose={this.handleClose} severity="error">
            {snackBarMsg}
          </Alert>
        </Snackbar>
        <div class="container-Cambia container-Cambia2 mt-3 mg-footer">
          <div class="tab-content tab-content2">
            <div class="container form-panel">
              <div class="form-group row">
                <div class="col-md-12">
                  <label
                    for="firstName"
                    class={firstNameError ? "error-label" : "control-label"}
                  >
                    First Name*
                  </label>

                  <input
                    type="text"
                    name="firstName"
                    placeholder="john"
                    class={firstNameError ? "error-input" : "form-control"}
                    value={firstName}
                    onChange={this.handleChange}
                    onBlur={this.handleOnBlur("firstName")}
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                  />
                  <br />
                  <label
                    for="lastName"
                    class={lastNameError ? "error-label" : "control-label"}
                  >
                    Last Name*
                  </label>

                  <input
                    type="text"
                    name="lastName"
                    placeholder="smith"
                    class={lastNameError ? "error-input" : "form-control"}
                    value={lastName}
                    onChange={this.handleChange}
                    onBlur={this.handleOnBlur("lastName")}
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                  />
                  <br />
                  <label
                    for="emailAddress"
                    class={emailError ? "error-label" : "control-label"}
                  >
                    <Text id="user.emailAdd" />*
                  </label>

                  <input
                    type="email"
                    name="email"
                    placeholder="john.smith@mail.com"
                    class={emailError ? "error-input" : "form-control"}
                    value={email}
                    onChange={this.handleChange}
                    onBlur={this.handleOnBlur("email")}
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                  />
                  <br />
                  <label
                    for="passwrd"
                    class={pswdError ? "error-label" : "control-label"}
                  >
                    <Text id="user.setValue" />*
                  </label>
                  <div className="user-sign-up-field-container">
                    <input
                      inputProps={{
                        type: showPswd ? "text" : "password",
                        autoComplete: "new-password",
                      }}
                      id="passwrd"
                      name="passwrd"
                      class={pswdError ? "error-input" : "form-control"}
                      value={signupKey}
                      onFocus={this.handleFocus("passwrd")}
                      onBlur={this.handleOnBlur("passwrd")}
                      onChange={this.handleChange}
                    />
                    {pswdEye ? (
                      <div
                        class="eyeIcon-password"
                        onMouseUp={this.showPswd("passwrd", false)}
                        onMouseDown={this.showPswd("passwrd", true)}
                        onMouseOut={this.showPswd("passwrd", false)}
                      >
                        <RemoveRedEyeIcon />
                      </div>
                    ) : null}
                  </div>
                  <br />
                  <label
                    for="reenterpwd"
                    class={
                      confirmPswdError ? "error-label" : "control-label"
                    }
                  >
                    <Text id="user.reEnter" />*
                  </label>
                  <div className="user-sign-up-field-container">
                    <input
                      inputProps={{
                        type: showConfirmPswd ? "text" : "password",
                        autoComplete: "new-password",
                      }}
                      id="confrmPasswrd"
                      class={
                        confirmPswdError ? "error-input" : "form-control"
                      }
                      autoFocus
                      name="confrmPasswrd"
                      value={confirmsignupKey}
                      onFocus={this.handleFocus("confrmPasswrd")}
                      onBlur={this.handleOnBlur("confrmPasswrd")}
                      onChange={this.handleChange}
                    />
                    {confirmPswdEye ? (
                      <div
                        class="eyeIcon-confirm-password"
                        onMouseUp={this.showPswd("confrmPasswrd", false)}
                        onMouseDown={this.showPswd("confrmPasswrd", true)}
                        onMouseOut={this.showPswd("confrmPasswrd", false)}
                      >
                        <RemoveRedEyeIcon onClick={this.showPswd} />
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div class="button-container-login-page">
                <div class="row">
                  <div class="col-md-6">
                    <button
                      class="btn-primary-continue"
                      id="signup"
                      onClick={this.signUp}
                      disabled={!this.state.modified}
                    >
                      <Text id="user.sign" />
                    </button>
                  </div>
                  <div class="col-md-6">
                    <div class="already-have-account">
                      <p>
                        <Text id="user.already" /> <br />
                        <a href="#none" onClick={this.login}>
                          <Text id="user.log" />
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <Footer1 /> */}
        <FooterContainer />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lang: state.webApp.language,
    customerId: state.login.customerId,
  };
};
const mapDispatchToProps = {
  signUp,
  guestLogin,
  successfulSignUp,
  setStateParams,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserSignUp);
